import { render, staticRenderFns } from "./instractions.vue?vue&type=template&id=50c68119&scoped=true"
import script from "./instractions.vue?vue&type=script&lang=js"
export * from "./instractions.vue?vue&type=script&lang=js"
import style0 from "./instractions.vue?vue&type=style&index=0&id=50c68119&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c68119",
  null
  
)

export default component.exports